import WebHeader from './components/WebHeader';
import getFeaturedMessage from './modules/featured';

export default WebHeader;
export { getFeaturedMessage };



// WEBPACK FOOTER //
// ./src/index.js